import { render } from "./BaAllDifferences.vue?vue&type=template&id=6562b786&ts=true"
import script from "./BaAllDifferences.vue?vue&type=script&lang=ts"
export * from "./BaAllDifferences.vue?vue&type=script&lang=ts"

import "./BaAllDifferences.vue?vue&type=style&index=0&id=6562b786&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__